import { Component, ViewChild, TemplateRef } from '@angular/core';
import { CertificadosService } from '../../../services/certificados.service';
import { Propiedades } from '../../../models/propiedades.model';
import { MatDialog } from '@angular/material';
import { FormService } from 'src/app/services/form.service';
import { FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';


declare var jQuery: any;
declare var $: any;

@Component({
    selector: "page-propiedades",
    templateUrl: "./propiedades.component.html",
    providers: [CertificadosService, FormService]
})

export class PropiedadesComponent {
    @ViewChild('openModal') openModal:TemplateRef<any>;
    @ViewChild('modalDirecciones') modalDirecciones: TemplateRef<any>;
    @ViewChild('openModalVerPorRol') openModalVerPorRol: TemplateRef<any>;
    public invalidRol: Boolean;
    public propiedades: Propiedades;
    public rows = [];
    public actualRow;
    public direcciones = [];
    public p: number = 1;
    public searchText
    public temp_dir;
    public isopen = false;
    public invalidDir;
    public rol = new FormControl('', [Validators.required ]);
    public dir = new FormControl('', [ Validators.required]);
    public num = new FormControl('', [Validators.required]);
    
    matcher = new FormService();
    //propiedades: { rol: string; id_direcc: string; folio: string; calle: string; calle_num: number; direccion_completa: string; direc_complemento: string; direc_compl_num: string; direc_anexo: string; direc_anexo_num: string; loteo: string; manzana: string; plano: string; ubicacion: string; recordId: string; };

    constructor(private _CertificadosService: CertificadosService, public dialog: MatDialog, 
        public _formService: FormService, private spinner: NgxSpinnerService){

        if(!JSON.parse(localStorage.getItem("propiedades"))){
            localStorage.setItem("propiedades", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("propiedades"));

        }
            this.invalidRol = true;
            this.propiedades = {rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', direc_anexo:'', direc_anexo_num:'', loteo:'', manzana:'', plano:'', ubicacion:'',valido:'', recordId:'', checked: false};
    }

    getPropiedades_rol(){
        this.spinner.show()
        this._CertificadosService.getPropiedades(this.rol.value,undefined, undefined, undefined).subscribe(
            response => {
                if(response.direcciones){
                    this.direcciones = response.direcciones;
                    this.dialog.open(this.modalDirecciones);
                    this.spinner.hide()
                } else {
                    if(response.message){
                        this.propiedades.rol = this.rol.value ? this.rol.value : '';
                        this.dialog.open(this.openModal);
                        this.spinner.hide()
                        
                    } else {
                        
                        this.propiedades.rol = response.rol ? response.rol : '';
                        this.propiedades.id_direcc = response.id_direcc ? response.id_direcc : '';
                        this.propiedades.folio = response.folio ? response.folio : '';
                        this.propiedades.calle = response.calle ? response.calle : '';
                        this.propiedades.calle_num = response.calle_num ? response.calle_num : '';
                        this.propiedades.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                        this.propiedades.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                        this.propiedades.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                        this.propiedades.direc_anexo = response.direc_anexo ? response.direc_anexo : '';
                        this.propiedades.direc_anexo_num = response.direc_anexo_num ? response.direc_anexo_num : '';
                        this.propiedades.loteo = response.loteo ? response.loteo : '';
                        this.propiedades.manzana = response.manzana ? response.manzana : '';
                        this.propiedades.plano = response.plano ? response.plano : '';
                        this.propiedades.ubicacion = response.ubicacion ? response.ubicacion : '';
                        this.propiedades.valido = response.valido ? response.valido : '';
                        this.propiedades.recordId = response.recordId ? response.recordId : '';
                        this.dialog.open(this.openModal);
                        this.spinner.hide()
                    }
                }
                

            },
            error => {
                console.log(error)
                this.spinner.hide()
            }
        )
    }

    getPropiedades_por_rol(rol, id){
        
        this.spinner.show()
        this._CertificadosService.getPropiedades(rol,id, undefined, undefined).subscribe(
            response => {
                if(response.direcciones){
                    this.direcciones = response.direcciones;
                    this.dialog.open(this.modalDirecciones);
                    this.spinner.hide()

                } else {
                    if(response.message){
                        this.propiedades.rol = this.rol.value ? this.rol.value : '';
                        this.dialog.open(this.openModalVerPorRol);
                        this.spinner.hide()
                        
                    } else {
                        
                        this.propiedades.rol = response.rol ? response.rol : '';
                        this.propiedades.id_direcc = response.id_direcc ? response.id_direcc : '';
                        this.propiedades.folio = response.folio ? response.folio : '';
                        this.propiedades.calle = response.calle ? response.calle : '';
                        this.propiedades.calle_num = response.calle_num ? response.calle_num : '';
                        this.propiedades.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                        this.propiedades.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                        this.propiedades.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                        this.propiedades.direc_anexo = response.direc_anexo ? response.direc_anexo : '';
                        this.propiedades.direc_anexo_num = response.direc_anexo_num ? response.direc_anexo_num : '';
                        this.propiedades.loteo = response.loteo ? response.loteo : '';
                        this.propiedades.manzana = response.manzana ? response.manzana : '';
                        this.propiedades.plano = response.plano ? response.plano : '';
                        this.propiedades.ubicacion = response.ubicacion ? response.ubicacion : '';
                        this.propiedades.valido = response.valido ? response.valido : '';
                        this.propiedades.recordId = response.recordId ? response.recordId : '';
                        this.dialog.open(this.openModalVerPorRol);
                        this.spinner.hide()
                    }
                }
                

            },
            error => {
                console.log(error)
                this.spinner.hide()
            }
        )
    }

    getPropiedades_dir(){
        this._CertificadosService.getPropiedades(undefined, this.dir.value, this.num.value).subscribe(
            response => {
                if(response.direcciones){
                    this.direcciones = response.direcciones;
                    this.dialog.open(this.modalDirecciones);

                } else {
                    if(response.message){
                        //this.propiedad.dir = dir ? dir : '';
                       // this.propiedad.num = num ? num : '';
                       this.dialog.open(this.openModal);
                    } else {
                        this.propiedades.rol = response.rol ? response.rol : '';
                        this.propiedades.id_direcc = response.id_direcc ? response.id_direcc : '';
                        this.propiedades.folio = response.folio ? response.folio : '';
                        this.propiedades.calle = response.calle ? response.calle : '';
                        this.propiedades.calle_num = response.calle_num ? response.calle_num : '';
                        this.propiedades.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                        this.propiedades.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                        this.propiedades.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                        this.propiedades.direc_anexo = response.direc_anexo ? response.direc_anexo : '';
                        this.propiedades.direc_anexo_num = response.direc_anexo_num ? response.direc_anexo_num : '';
                        this.propiedades.loteo = response.loteo ? response.loteo : '';
                        this.propiedades.manzana = response.manzana ? response.manzana : '';
                        this.propiedades.plano = response.plano ? response.plano : '';
                        this.propiedades.ubicacion = response.ubicacion ? response.ubicacion : '';
                        this.propiedades.valido = response.valido ? response.valido : '';
                        this.propiedades.recordId = response.recordId ? response.recordId : '';
                        this.dialog.open(this.openModal);
                        this.isopen = false;
                    }
                }
                
            },
            error => {
                console.log(error);
                this.isopen = false;
            }
        )
    }

    cleanData(){
        this.propiedades = {rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', direc_anexo:'', direc_anexo_num:'', loteo:'', manzana:'', plano:'', ubicacion:'',valido:'', recordId:''};
        this.rol.reset();
        this.num.reset();
        this.dir.reset();
    }

    savePropiedades(){
        $("#dir_modal").modal("hide");
        this.actualRow = localStorage.getItem("propiedades");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            rol: this.propiedades.rol,
            id_direcc: this.propiedades.id_direcc,
            folio: this.propiedades.folio,
            calle: this.propiedades.calle,
            calle_num: this.propiedades.calle_num,
            direccion_completa: this.propiedades.direccion_completa,
            direc_complemento: this.propiedades.direc_complemento,
            direc_compl_num: this.propiedades.direc_compl_num,
            direc_anexo: this.propiedades.direc_anexo,
            direc_anexo_num: this.propiedades.direc_anexo_num,
            loteo: this.propiedades.loteo,
            manzana: this.propiedades.manzana,
            plano: this.propiedades.plano,
            ubicacion: this.propiedades.ubicacion,
            valido: this.propiedades.valido,
            recordId: this.propiedades.recordId
        })
        localStorage.setItem("propiedades", JSON.stringify(this.rows));
        this.propiedades = {rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', direc_anexo:'', direc_anexo_num:'', loteo:'', manzana:'', plano:'', ubicacion:'', valido:'', recordId:''};
        this.num.reset();
        this.rol.reset();     
        this.dir.reset();
        this.dialog.closeAll();
        
    }

    savePropiedadesMulti(direccion){
        $("#dir_modal2").modal("hide");
        this.actualRow = localStorage.getItem("propiedades");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            rol: direccion.rol ? direccion.rol : '',
            id_direcc: direccion.id_direcc ? direccion.id_direcc : '',
            folio: direccion.folio ? direccion.folio : '',
            calle: direccion.calle ? direccion.calle : '',
            calle_num: direccion.calle_num ? direccion.calle_num : '',
            direccion_completa: direccion.direccion_completa ? direccion.direccion_completa : '',
            direc_complemento: direccion.direc_complemento ? direccion.direc_complemento : '',
            direc_compl_num: direccion.direc_compl_num ? direccion.direc_compl_num : '',
            direc_anexo: direccion.direc_anexo ? direccion.direc_anexo : '',
            direc_anexo_num: direccion.direc_anexo_num ? direccion.direc_anexo_num : '',
            loteo: direccion.loteo ? direccion.loteo : '',
            manzana: direccion.manzana ? direccion.manzana : '',
            plano: direccion.plano ? direccion.plano : '',
            ubicacion: direccion.ubicacion ? direccion.ubicacion : '',
            valido: direccion.valido ? direccion.valido : '',
            recordId: direccion.recordId ? direccion.recordId : ''
        })
        localStorage.setItem("propiedades", JSON.stringify(this.rows));
        this.propiedades = {rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', direc_anexo:'', direc_anexo_num:'', loteo:'', manzana:'', plano:'', ubicacion:'', valido:'',recordId:''};
        this.rol.reset();
        this.num.reset();
        this.dir.reset();
        this.dialog.closeAll();
    }

    deletePropiedades(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("propiedades", JSON.stringify(this.rows));
            }
        }
    }
}